// Utilidades del enlace a la documentación de usuario (docs.islait.es) en la intranet.
// El valor `docsUrl` llega ya saneado del applier (config.brand.docsUrl); estas funciones
// aplican una GUARDA DEFENSIVA extra en el front: solo http(s), para que un valor manipulado
// del config.json nunca produzca un href ejecutable. La intranet es web (sin Capacitor), así
// que el enlace es un <a target="_blank"> normal — no hace falta abrir programáticamente.

/** true solo si `value` es una URL http(s) con algo tras el esquema. */
export const isHttpUrl = (value) =>
  typeof value === 'string' && /^https?:\/\/.+/i.test(value);

/** Une base + path relativa sin producir doble barra. */
export const joinDocsUrl = (base, path) =>
  `${base.replace(/\/+$/, '')}/${path.replace(/^\/+/, '')}`;
